export enum TEST_POPULATION_TYPES {
  //
  //   ENGLISH
  //
  TEST_R_MC_SHORT, // multiple choice
  TEST_R_MC_MEDIUM,
  TEST_R_MC_LONG,
  TEST_R_MC_PASSAGE_SHORT,
  TEST_R_MC_PASSAGE_MEDIUM,
  TEST_R_MC_PASSAGE_LONG,
  TEST_R_MC_PASSAGE_SHORT_WITH_TITLE,
  TEST_R_MC_PASSAGE_MEDIUM_WITH_TITLE,
  TEST_R_MC_PASSAGE_LONG_WITH_TITLE,
  TEST_R_MC_PASSAGE_VERBAL,
  TEST_R_MC_TITLE_SHORT,
  TEST_R_MC_TITLE_MEDIUM,
  TEST_R_MC_TITLE_LONG,
  TEST_R_MC_MEDIUM_VERBAL,
  TEST_R_MCI_SHORT, // multiple choice with images
  TEST_R_MCI_MEDIUM,
  TEST_R_MCI_LONG,
  TEST_R_MCI_PASSAGE_SHORT,
  TEST_R_MCI_PASSAGE_MEDIUM,
  TEST_R_MCI_PASSAGE_LONG,
  TEST_R_MCI_PASSAGE_VERBAL,
  TEST_R_MCI_MEDIUM_VERBAL,
  TEST_R_MS_SHORT, // multiple select
  TEST_R_MS_MEDIUM,
  TEST_R_MS_LONG,
  TEST_R_MS_PASSAGE_SHORT,
  TEST_R_MS_PASSAGE_MEDIUM,
  TEST_R_MS_PASSAGE_LONG,
  TEST_R_MS_PASSAGE_VERBAL,
  TEST_R_MS_MEDIUM_VERBAL,
  TEST_R_MSI_SHORT,
  TEST_R_MSI_MEDIUM,
  TEST_R_MSI_LONG,
  TEST_R_MSI_PASSAGE_SHORT,
  TEST_R_MSI_PASSAGE_MEDIUM,
  TEST_R_MSI_PASSAGE_LONG,
  TEST_R_MSI_PASSAGE_VERBAL,
  TEST_R_MSI_MEDIUM_VERBAL,
  TEST_R_TE_SHORT, // text entry
  TEST_R_TE_MEDIUM,
  TEST_R_TE_LONG,
  TEST_R_TE_MEDIUM_VERBAL,
  TEST_R_IC_SHORT, // inline choice
  TEST_R_IC_MEDIUM,
  TEST_R_IC_LONG,
  TEST_R_MC_TRUE_FALSE,
  TEST_R_MC_PASSAGE_TRUE_FALSE,
  TEST_R_SCR_SHORT, // short constructed response
  TEST_R_SCR_MEDIUM,
  TEST_R_SCR_LONG,
  TEST_R_SCR_PASSAGE_SHORT,
  TEST_R_SCR_PASSAGE_MEDIUM,
  TEST_R_SCR_PASSAGE_LONG,
  TEST_R_SCRR_SHORT, // short constructed response with rubric
  TEST_R_SCRR_MEDIUM,
  TEST_R_SCRR_LONG,
  TEST_R_SCRR_PASSAGE_SHORT,
  TEST_R_SCRR_PASSAGE_MEDIUM,
  TEST_R_SCRR_PASSAGE_LONG,
  TEST_R_ECR_SHORT, // extended constructed response
  TEST_R_ECR_MEDIUM,
  TEST_R_ECR_LONG,
  TEST_R_ECR_PASSAGE_SHORT,
  TEST_R_ECR_PASSAGE_MEDIUM,
  TEST_R_ECR_PASSAGE_LONG,
  TEST_R_ECRR_SHORT, // extended constructed response with rubric
  TEST_R_ECRR_MEDIUM,
  TEST_R_ECRR_LONG,
  TEST_R_ECRR_PASSAGE_SHORT,
  TEST_R_ECRR_PASSAGE_MEDIUM,
  TEST_R_ECRR_PASSAGE_LONG,
  TEST_R_DND_BLANK_SHORT, // drag and drop fill in the blank
  TEST_R_DND_BLANK_LONG,
  TEST_R_DND_BLANK_SHORT_1_TRY,
  TEST_R_DND_BLANK_VERBAL,
  TEST_R_DND_SEQ_STATIC_HORZ_SHORT, // drag and drop sequencing static horizontal
  TEST_R_DND_SEQ_STATIC_HORZ_LONG,
  TEST_R_DND_SEQ_STATIC_VERT_SHORT, // drag and drop sequencing static vertical
  TEST_R_DND_SEQ_STATIC_VERT_LONG,
  TEST_R_DND_SORT_BUCKETS_SHORT, // drag and drop sorting buckets
  TEST_R_DND_SORT_BUCKETS_LONG,
  TEST_R_DND_SORT_BUCKETS_SHORT_4_TRY,
  TEST_R_DND_SORTING_BUCKETS_IMAGES_1,
  TEST_R_DND_SORTING_BUCKETS_IMAGES_2,
  TEST_R_MC_MEDIUM_1_TRY,
  TEST_R_MCI_MEDIUM_2_TRY,
  TEST_R_MS_MEDIUM_3_TRY,
  TEST_R_MSI_MEDIUM_1_TRY,
  TEST_R_TE_MEDIUM_2_TRY,
  TEST_R_IC_MEDIUM_3_TRY,
  TEST_R_DND_GRID_1X6X4, // drag and drop grid
  TEST_R_DND_GRID_1X5X3,
  TEST_R_DND_GRID_MATCH_2X6X4, // drag and drop grid match
  TEST_R_DND_GRID_MATCH_1X5X3,
  TEST_R_DND_GRID_MATCH_2X5X10,
  TEST_R_DND_BLANK_VERBAL_WITH_VIDEO,
  TEST_R_DND_BLANK_WITH_VIDEO,
  TEST_R_DND_BLANK,
  TEST_R_DND_WITH_REPEAT_OPTIONS,
  TEST_R_DND_BLANK_WITH_REPEAT_OPTIONS,
  TEST_R_DND_BLANK_VERBAL_AND_VIDEO_WITH_REPEAT_OPTIONS,

  //
  //   SPANISH
  //
  TEST_S_MC_SHORT, // short multiple choice spanish
  TEST_S_MC_MEDIUM,
  TEST_S_MC_LONG,
  TEST_S_MC_PASSAGE_SHORT,
  TEST_S_MC_PASSAGE_MEDIUM,
  TEST_S_MC_PASSAGE_LONG,
  TEST_S_MCI_SHORT, // multiple choice with images spanish
  TEST_S_MCI_MEDIUM,
  TEST_S_MCI_LONG,
  TEST_S_MCI_PASSAGE_SHORT,
  TEST_S_MCI_PASSAGE_MEDIUM,
  TEST_S_MCI_PASSAGE_LONG,
  TEST_S_MS_SHORT, // multiple select spanish
  TEST_S_MS_MEDIUM,
  TEST_S_MS_LONG,
  TEST_S_MS_PASSAGE_SHORT,
  TEST_S_MS_PASSAGE_MEDIUM,
  TEST_S_MS_PASSAGE_LONG,
  TEST_S_MSI_SHORT, // multiple select with images spanish
  TEST_S_MSI_MEDIUM,
  TEST_S_MSI_LONG,
  TEST_S_MSI_PASSAGE_SHORT,
  TEST_S_MSI_PASSAGE_MEDIUM,
  TEST_S_MSI_PASSAGE_LONG,
  TEST_S_TE_SHORT, // text entry spanish
  TEST_S_TE_MEDIUM,
  TEST_S_TE_LONG,
  TEST_S_IC_SHORT, // inline choice spanish
  TEST_S_IC_MEDIUM,
  TEST_S_IC_LONG,
  TEST_S_MC_TRUE_FALSE, // multiple choice true false spanish
  TEST_S_MC_PASSAGE_TRUE_FALSE, // multiple choice true false spanish passage
  TEST_S_SCR_SHORT, // short constructed response spanish
  TEST_S_SCR_MEDIUM,
  TEST_S_SCR_LONG,
  TEST_S_SCRR_SHORT, // short constructed response with rubric spanish
  TEST_S_SCRR_MEDIUM,
  TEST_S_SCRR_LONG, // short constructed response with rubric spanish
  TEST_S_SCR_PASSAGE_SHORT,
  TEST_S_SCR_PASSAGE_MEDIUM,
  TEST_S_SCR_PASSAGE_LONG,
  TEST_S_SCRR_PASSAGE_SHORT,
  TEST_S_SCRR_PASSAGE_MEDIUM,
  TEST_S_SCRR_PASSAGE_LONG,
  TEST_S_ECR_SHORT, // extended constructed response spanish
  TEST_S_ECR_MEDIUM,
  TEST_S_ECR_LONG,
  TEST_S_ECRR_SHORT, // extended constructed response with rubric spanish
  TEST_S_ECRR_MEDIUM,
  TEST_S_ECRR_LONG,
  TEST_S_ECR_PASSAGE_SHORT,
  TEST_S_ECR_PASSAGE_MEDIUM,
  TEST_S_ECR_PASSAGE_LONG,
  TEST_S_ECRR_PASSAGE_SHORT,
  TEST_S_ECRR_PASSAGE_MEDIUM,
  TEST_S_ECRR_PASSAGE_LONG,
  //
  //   MATH
  //
  TEST_M_SCR_SHORT, // short constructed response math
  TEST_M_SCR_MEDIUM,
  TEST_M_SCR_LONG,
  TEST_M_SCR_PASSAGE_SHORT,
  TEST_M_SCR_PASSAGE_MEDIUM,
  TEST_M_SCR_PASSAGE_LONG,
  TEST_M_SCRR_SHORT, // short constructed response with rubric math
  TEST_M_SCRR_MEDIUM,
  TEST_M_SCRR_LONG,
  TEST_M_SCRR_PASSAGE_SHORT,
  TEST_M_SCRR_PASSAGE_MEDIUM,
  TEST_M_SCRR_PASSAGE_LONG,
  TEST_M_ECR_SHORT, // extended constructed response math
  TEST_M_ECR_MEDIUM,
  TEST_M_ECR_LONG,
  TEST_M_ECR_PASSAGE_SHORT,
  TEST_M_ECR_PASSAGE_MEDIUM,
  TEST_M_ECR_PASSAGE_LONG,
  TEST_M_ECRR_SHORT,
  TEST_M_ECRR_MEDIUM,
  TEST_M_ECRR_LONG,
  TEST_M_ECRR_PASSAGE_SHORT,
  TEST_M_ECRR_PASSAGE_MEDIUM,
  TEST_M_ECRR_PASSAGE_LONG,
  TEST_M_DND_STATIC_HORIZ_SEQ, // drag and drop static horizontal sequence math
  TEST_M_DND_DYNAMIC_HORIZ_SEQ, // drag and drop dynamic horizontal sequence math
  TEST_M_DND_STATIC_VERT_SEQ, // drag and drop static vertical sequence math
  TEST_M_DND_FILL_BLANK_1, // drag and drop fill in the blank math
  TEST_M_DND_FILL_BLANK_2,
  TEST_M_DND_FILL_BLANK_3,
  TEST_M_DND_FILL_BLANK_4,
  TEST_M_DND_FILL_BLANK_5,
  TEST_M_DND_SORTING_BUCKETS_1, // drag and drop sorting buckets math
  TEST_M_DND_SORTING_BUCKETS_2,
  TEST_M_DND_SORTING_BUCKETS_3,
  TEST_HOT_TEXT_ONE_WORD,
  TEST_HOT_TEXT_ONE_PHRASE,
  TEST_HOT_TEXT_MULTIPLE_WORDS,
  TEST_HOT_TEXT_MULTIPLE_PHRASES,
  TEST_HOT_TEXT_MULTIPLE_WORDS_MULTIPLE_PHRASES,
}
